import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { AnyMxRecord } from 'dns';

@Injectable({
  providedIn: 'root',
})
export class DbService {
  constructor(private http: HttpClient) { }

  uploadImage(files: File[]) {
    const formData = new FormData();
    Array.from(files).forEach((f) => formData.append('userfile', f));
    return this.http.post(
      environment.baseUrl + 'GlobalVariable/upload_image',
      formData
    );
  }

  uploadFile(files: File[]) {
    const formData = new FormData();
    Array.from(files).forEach((f) => formData.append('userfile', f));
    return this.http.post(
      environment.baseUrl + 'GlobalVariable/upload_image',
      formData
    );
  }




  eventsave(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.eventsave,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  editevent(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.editevent,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  eventall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.eventall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  deleteevent(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.deleteevent,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  geteventid(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.geteventid,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  eventregistrationsave(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.eventregistrationsave,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  editeventregistration(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.editeventregistration,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  eventregistrationall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.eventregistrationall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  deleteeventregistration(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.deleteeventregistration,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  geteventregistrationid(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.geteventregistrationid,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  savelogindatabase(
    user: any,
    component: any,
    operation: any,
    data: any,
    number: any
  ) {
    let payload = new FormData();
    const now = new Date();

    payload.append('id', '');
    payload.append('user', user);
    payload.append('component', component);
    payload.append('operation', operation);
    payload.append('data', JSON.stringify(data));
    payload.append('number', number);
    this.savelog(payload).subscribe(
      (response: any) => {
        if (response && response?.status === 200) {
        } else {
        }
      },
      (error) => {}
    );
  }

  savelog(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.savelog,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  deleteusers(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.deleteusers,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  saveusers(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.saveusers,
      payload
      ,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getusers(id: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getusers,
      id      ,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  send_usercreationmail(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.send_usercreationmail,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
    
  }
  getAllusers() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.usersList,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  updateusers(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.updateusers,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  saveSettings(payload: any) {
    //return this.http.post((environment.baseUrl + environment.apiUrls.apis.saveSettings), payload);

    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.saveSettings,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  deleteSettings(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.deleteSettings,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );

    //return this.http.post((environment.baseUrl + environment.apiUrls.apis.deleteSettings), payload);
  }
  updateSettings(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.updateSettings,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
    //return this.http.post((environment.baseUrl + environment.apiUrls.apis.updateSettings), payload);
  }
  getParameterList() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.getParameterList,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
    //return this.http.post((environment.baseUrl + environment.apiUrls.apis.updateSettings), payload);
  }
  getType(type: any) {
    //return this.http.get(environment.baseUrl + environment.apiUrls.apis.getState);
    //return this.http.post((environment.baseUrl + environment.apiUrls.apis.getType), type);

    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getType,
      type,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getlogreport(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getlogreport,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  subscriptionplansave(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.subscriptionplansave,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  editsubscriptionplan(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.editsubscriptionplan,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  subscriptionplanall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.subscriptionplanall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  deletesubscriptionplan(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.deletesubscriptionplan,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getsubscriptionplanid(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getsubscriptionplanid,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getregistrationall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.getregistrationall,
      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  subscriptionplans(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.subscriptionplans,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getmobile(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getmobile,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getotpdetails(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getotpdetails,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getregistrationdetails(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getregistrationdetails,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getimagesid(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getimagebyid,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getimagebylimit(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getimagebylimit,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }


  whatsappgroupsall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.whatsappgroupsall,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getwhatsagroupbylimit(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getwhatsagroupbylimit,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }


  
  getCatgeoryByType(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getCatgeoryByType,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

    
  getAifType(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getAifType,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

    
  getInsuranceByType(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getInsuranceByType,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }


  nfoall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.nfoall,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  contactall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.contactall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  comitteeall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.comitteeall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  bloglist() {
    return this.http.get(
      environment.apiUrls.apis.bloglist
    );
  }

  knowledgelist() {
    return this.http.get(
      environment.apiUrls.apis.knowledgelist
    );
  }

  newslist() {
    return this.http.get(
      environment.apiUrls.apis.newslist
    );
  }

  rtaall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.rtaall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  
  getCreativesBySubCategory(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getCreativesBySubCategory,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  creativecategoryall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.creativecategoryall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getByCreativeCategory(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getByCreativeCategory,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getsubscriptionplansbytype(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getsubscriptionplansbytype,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }



  getcreativesbyid(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getcreativesbyid,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  trainingsall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.trainingsall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getsponsorsall() {
    return this.http.get((environment.baseUrl + environment.apiUrls.apis.getAllsponsors), {
      headers: new HttpHeaders().set('Basic', `${environment.authToken}`)
    });
  }	 

  getmemberotpdetails(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getmemberotpdetails,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }


  editmember(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.editmember,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  savemember(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.savemember,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getmemberdetails(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getmemberdetails,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }

  getByPhoneNumber(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getByPhoneNumber,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }


  getPayUHash(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getPayUHash,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }


  paymentssave(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.paymentssave,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  editpayments(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.editpayments,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  paymentsall() {
    return this.http.get(
      environment.baseUrl + environment.apiUrls.apis.paymentsall,      
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  deletepayments(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.deletepayments,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getpaymentsid(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getpaymentsid,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  getPaymentByMember(payload: any) {
    return this.http.post(
      environment.baseUrl + environment.apiUrls.apis.getPaymentByMember,
      payload,
      {
        headers: new HttpHeaders().set('Basic', `${environment.authToken}`),
      }
    );
  }
  
}

